/**
 * The side panel currently open in the task editor. Only one side panel can be open at a time.
 */ export var TaskEditorSidePanelType = /*#__PURE__*/ function(TaskEditorSidePanelType) {
    /** No side panel is open */ TaskEditorSidePanelType["None"] = "none";
    /** The chat side panel is open */ TaskEditorSidePanelType["Chat"] = "chat";
    /** The history side panel is open */ TaskEditorSidePanelType["History"] = "history";
    return TaskEditorSidePanelType;
}({});
